// Lightweight IndexNow pinger with debounce
const INDEXNOW_KEY = '/indexnow.txt';
const INDEXNOW_ENDPOINTS = [
  'https://api.indexnow.org/indexnow',
  'https://www.bing.com/indexnow',
];

let lastPing = 0;
const PING_INTERVAL_MS = 60_000; // min 1 minute entre pings

function getCanonicalFromLocation(): string {
  try {
    const u = new URL(window.location.href);
    u.hash = '';
    u.search = '';
    return u.origin + (u.pathname === '/' ? '/' : u.pathname.replace(/\/+$/, ''));
  } catch {
    return window.location.href;
  }
}

async function fetchKey(): Promise<string | null> {
  try {
    const res = await fetch(INDEXNOW_KEY, { cache: 'no-store' });
    if (!res.ok) return null;
    return (await res.text()).trim();
  } catch {
    return null;
  }
}

export async function pingIndexNow(url?: string) {
  const now = Date.now();
  if (now - lastPing < PING_INTERVAL_MS) return;
  lastPing = now;

  const key = await fetchKey();
  if (!key) return;

  const targetUrl = url ?? getCanonicalFromLocation();
  const body = {
    host: window.location.origin.replace(/^https?:\/\//, ''),
    key,
    urlList: [targetUrl]
  };

  try {
    await Promise.all(
      INDEXNOW_ENDPOINTS.map((ep) =>
        fetch(ep, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        }).catch(() => void 0)
      )
    );
  } catch {
    // noop
  }
}

export function setupIndexNowListener() {
  // ping at first load
  pingIndexNow();
  // ping on route changes
  window.addEventListener('popstate', () => pingIndexNow());
  const pushState = window.history.pushState.bind(window.history);
  const replaceState = window.history.replaceState.bind(window.history);
  window.history.pushState = function(...args: any[]) {
    // @ts-ignore
    const ret = pushState.apply(this, args);
    pingIndexNow();
    return ret;
  } as any;
  window.history.replaceState = function(...args: any[]) {
    // @ts-ignore
    const ret = replaceState.apply(this, args);
    pingIndexNow();
    return ret;
  } as any;
}


